module.exports = __webpack_public_path__ + "fa95d473b76af8a090428ac8eb5da429.png";